import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

const SatelliteIndexChart = ({ title, data, color = '#2FB95D' }) => {
    if (!data || !data.dates || !data.values) return null;

    const chartData = {
        labels: data.dates,
        datasets: [
            {
                label: title,
                data: data.values,
                borderColor: color,
                backgroundColor: (context) => {
                    const ctx = context.chart.ctx;
                    const gradient = ctx.createLinearGradient(0, 0, 0, 300);
                    gradient.addColorStop(0, `${color}33`);
                    gradient.addColorStop(1, `${color}05`);
                    return gradient;
                },
                tension: 0.3,
                fill: true,
                pointRadius: 4,
                pointBackgroundColor: color,
                borderWidth: 2
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                mode: 'index',
                intersect: false,
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 16,
                    weight: 'bold'
                }
            }
        },
        scales: {
            x: {
                grid: {
                    display: false
                },
                ticks: {
                    maxRotation: 45,
                    minRotation: 45
                }
            },
            y: {
                beginAtZero: false,
                grid: {
                    color: 'rgba(0,0,0,0.05)'
                }
            }
        }
    };

    return (
        <div className="h-64 w-full bg-white p-4 rounded-xl shadow-sm border border-gray-100">
            <Line data={chartData} options={options} />
        </div>
    );
};

export default SatelliteIndexChart;
